const fromAppointmentTypeQueryToAppointmentType = (appointmentTypeDataQuery)=>{
    if (!appointmentTypeDataQuery) {
        return null;
    }
    try {
        const { id , name , description , duration , ageGroup , visibleToCustomers , groupId  } = appointmentTypeDataQuery;
        return {
            id,
            name,
            description,
            ageGroup,
            duration: {
                amount: duration.amount,
                unit: duration.unit
            },
            isVisibleToCustomers: visibleToCustomers,
            groupId: groupId !== null && groupId !== void 0 ? groupId : undefined
        };
    } catch (e) {
        console.error('Appointment type query data adapter failed to parse input data correctly.', e, appointmentTypeDataQuery);
        return null;
    }
};

export { fromAppointmentTypeQueryToAppointmentType };
//# sourceMappingURL=from-appointment-type-query-to-appointment-type.js.map
